import actions from './constants';
// import { getToken } from '../services/utils';

const initialState = {
    loading: false,
    errorMessage: "",
    successMessage: "",
    userInfo: {
    },
    // isLoggedIn: !!getToken(),
    isLoggedIn:false
};

const reducers = (state = initialState, action) => {
    switch (action.type) {
        case actions.SHOW_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: action.payload
            };
        case actions.SHOW_SUCCESS_MESSAGE:
            return {
                ...state,
                successMessage: action.payload
            }
        case actions.UPDATE_USER_INFO:
            return {
                ...state,
                userInfo: action.payload
            };
        case actions.UPDATE_LOADING:
            return {
                ...state,
                loading: action.payload
            }
        case actions.LOGOUT:
            return {
                ...state,
                isLoggedIn: false,
                userInfo: {
                    name:"",
                    id:"",
                    meters:[],
                    role:{}
                }
            }
        case actions.SET_ACCESS_TOKEN:
            return {
                ...state,
                isLoggedIn: true
            }
        case actions.UPDATE_USER_METERS:
            return {
                ...state,
                userInfo:{
                    ...state.userInfo,
                    meters:action.payload
                }
            }
        default:
            return state;
    }
};

export default reducers;